module.exports = {template: '<svg data-name="Слой 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 87.41"><title>social</title><path d="M70.62 0A26 26 0 0 0 50 9.56 26 26 0 0 0 29.38 0C11.81 0 0 16.28 0 31.48c0 22.13 42.52 51.8 47.37 55.11a4.68 4.68 0 0 0 5.27 0c4.85-3.31 47.37-33 47.37-55.11C100 16.28 88.19 0 70.62 0zM50 77.04C33.26 65.13 9.34 43.82 9.34 31.48c0-9.28 7-22.14 20-22.14 11.89 0 16.09 10.27 16.25 10.68a4.67 4.67 0 0 0 4.34 3 4.7 4.7 0 0 0 4.35-3c.17-.44 4.37-10.71 16.26-10.71 13.07 0 20 12.86 20 22.14.12 12.35-23.8 33.67-40.54 45.59z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/social.svg
// module id = 563
// module chunks = 1